export default __webpack_public_path__ + "static/timberline-warranty-toptile-7d553bd8cf52763dafd5cff69896d6fa.jpg";